<template>
  <div class="target inner" id="jzrenwumubiao">
    <div class="target-tt slidetop" v-animate-onscroll="'animateMove'">任务目标</div>
    <!--<div class="target-btn">
      <div class="target-btn-item">
        <router-link to="/task">
          <span>主要任务</span>
        </router-link>
      </div>
      <div class="target-btn-item">
        <router-link to="/task">
          <span>建设目标</span>
        </router-link>
      </div>
      <div class="target-btn-item">
        <router-link to="/task">
          <span>运行机制</span>
        </router-link>
      </div>
    </div>-->
    <div class="task-li">
      <ul class="task-fix">
        <li>
          <router-link :to="`/task?layIndex=0`">
            <b class="iconfont">&#xe64b;</b>
            <span>建设指引</span>
          </router-link>
        </li>
        <li>
          <router-link :to="`/task?layIndex=1`">
            <b class="iconfont">&#xe62a;</b>
            <span>总体目标</span>
          </router-link>
        </li>
        <li>
          <router-link :to="`/task?layIndex=2`">
            <b class="iconfont">&#xe63f;</b>
            <span>中心任务</span>
          </router-link>
        </li>
        <li>
          <router-link :to="`/task?layIndex=3`">
          <b class="iconfont">&#xe622;</b>
          <span>体制机制</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      targeData: {},
      activeIndex: 0
    }
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/fdata/article_pagelist_show?catid=86')
      if (res.code === 1) {
        this.targeData = res.data.info
        console.log(this.targeData)
      }
    },
    targetTask(index) {
      this.activeIndex = index
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
</style>
